<div *ngIf="detalhesPedidoService.mostrarPopDetalhesPedido && detalhesPedidoService.detalhesPedidos">
  <div class="modal-confirm">
    <div class="modal-conteudo">
      <div class="header-modal">
        <span>Lista de produtos {{ detalhesPedidoService.motivoColeta != null ? 'da coleta' : 'do pedido' }} </span>
        <img id="close-modal-btn"  class='bt-fechar' style="cursor: pointer;" src="assets/img/icons/close-white.svg" (click)="fecharModal()">
      </div>
      <div class="modal-conteudo">
        <div *ngIf="detalhesPedidoService.chaveAcesso != null" class="chaveAcesso">
          <span >Chave nota fiscal: <span class="numeroChaveAcesso ms-2">{{ detalhesPedidoService.chaveAcesso }}</span></span>
        </div>

        <div *ngIf="detalhesPedidoService.motivoColeta != null" class="chaveAcesso">
            <span >Motivo Coleta: <span class="numeroChaveAcesso ms-2">{{ detalhesPedidoService.motivoColeta }}</span></span>
        </div>
        
        <div class="content table-container mt-3">
          <table  class="table table-striped table-sm">
            <thead>
              <tr>
                <th scope="col">Produto</th>
                <th scope="col">Qtd.</th>
              </tr>
            </thead>
            <tbody >
              <tr *ngFor="let item of detalhesPedidoService.detalhesPedidos">
                <td>{{ item.cdProd }} - {{ item.descricaoProduto  | truncate:40 }}</td>
                <td>{{ item.quantidade.toString().replace('.',',') }}</td>
              </tr>          
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

